import React from 'react';
import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';
import 'highlight.js/styles/github.css'; // Подсветка кода

interface MarkdownEditorProps {
  value: string;
  onChange: (val: string | undefined) => void;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({ value, onChange }) => {
  return (
    <div data-color-mode="light">
      <MDEditor
        value={value}
        onChange={onChange}
        preview="edit"
        height={300}
        previewOptions={{
          // Можно добавить remarkPlugins для GFM, если потребуется
        }}
      />
    </div>
  );
};

export default MarkdownEditor; 